/* eslint-disable  */

// ** React Imports
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Fragment, useState, useEffect } from "react";
import { users } from "@api/Api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { getAllMenu } from "../redux/layout";
// ** Core Layout Import
import BaseLayout from "@layouts/VerticalLayout";
import { hasPermission, hasManyPermission } from "@utils";

import {
  Mail,
  MessageSquare,
  CheckSquare,
  Calendar,
  FileText,
  Circle,
  ShoppingCart,
  User,
  Shield,
  Square,
  Box,
  DollarSign,
  Percent,
  Star,
  Map,
  Slash,
  Layout,
} from "react-feather";
// ** Menu Items Array
import navigation from "@src/navigation/vertical";
import { setAuthToken, APIClient } from "../api/_api";
const VerticalLayout = (props) => {
  const dispatch = useDispatch();
  const [menuData, setMenuData] = useState([]);
  const location = useLocation();
  const store = useSelector((state) => state.layout, shallowEqual);
  // ** For ServerSide navigation

  useEffect(() => {
    const token =
      localStorage.getItem("accessToken") &&
      localStorage.getItem("accessToken");
    if (!token) {
      return;
    }

    // if (hasManyPermission(["owner"])) {
    const menuLocalStorage = localStorage.getItem("menu");

    if (menuLocalStorage) {
      getMenuLocal(menuLocalStorage);

      // setMenuData(JSON.parse(menuLocalStorage));
    } else {
      setTimeout(async () => {
        if (!store.menuFetched) {
          dispatch(getAllMenu()).then(async (response) => {
            const menuLocal = await getMenu(response?.payload?.data?.data);
            localStorage.setItem(
              "menu",
              JSON.stringify(response?.payload?.data?.data)
            );
            setMenuData(menuLocal);
          });
        } else {
          const menuLocal = await getMenu(store.menu);
          console.log("menuLocal", menuLocal);
          localStorage.setItem("menu", JSON.stringify(store.menu));
          setMenuData(menuLocal);
        }

        console.log(store);
      }, 2000);
    }
    // }
  }, []);

  const getMenuLocal = async (menuLocalStorage) => {
    if (!menuLocalStorage || String(menuLocalStorage) === "undefined") {
      localStorage.removeItem("menu");
      window.location.reload();
      return;
    }
    const menuLocal = await getMenu(JSON.parse(menuLocalStorage));
    setMenuData(menuLocal);
  };

  const getMenu = async (response) => {
    const currentPath = location.pathname;
    const iconComponents = {
      Mail,
      MessageSquare,
      CheckSquare,
      Calendar,
      FileText,
      Circle,
      ShoppingCart,
      User,
      Shield,
      Square,
      Box,
      DollarSign,
      Percent,
      Star,
      Map,
      Slash,
      Layout,
    };

    try {
      const modifiedData = await response.map((item) => ({
        ...item,
        disabled: currentPath === "/apps/ContractSeeLib" ? true : false,
        // icon: React.createElement(iconComponents[item.iconName], {
        //   size: 20,
        // }),

        icon: <FontAwesomeIcon icon={`fa-solid ${item.iconName}`} />,
        id: item.key,
      }));

      for (const item of modifiedData) {
        if (item?.children?.length === 0) {
          delete item?.children;
        } else {
          item.children = item.children.map((child) => ({
            ...child,
            disabled: currentPath === "/apps/ContractSeeLib" ? true : false,
          }));
        }

        // Iterate through children and add the disabled property

        delete item?.iconName;
        delete item?.iconSize;
        delete item?.sort;
      }
      return modifiedData;
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <BaseLayout menuData={menuData} {...props}>
      <Outlet />
    </BaseLayout>
  );
};

export default VerticalLayout;
